/**
 * Trích root domain từ hostname.
 * VD: "app.example.com" → "example.com"
 * Trả null cho localhost, IP, hostname < 2 phần.
 */
export function getRootDomain(hostname: string): string | null {
  if (!hostname || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null
  }
  const parts = hostname.split('.')
  if (parts.length < 2) return null
  return parts.slice(-2).join('.')
}

/**
 * So sánh 2 URL có cùng root domain không.
 * VD: "https://sso.example.com" vs "https://app.example.com" → true
 */
export function isSameRootDomain(url1: string, url2: string): boolean {
  try {
    const a = new URL(url1)
    const b = new URL(url2)
    const rootA = getRootDomain(a.hostname)
    const rootB = getRootDomain(b.hostname)
    return rootA !== null && rootA === rootB
  } catch {
    return false
  }
}
